<h1 mat-dialog-title>Change role</h1>
<div mat-dialog-content>
  <div class="user">
    <div class="user-name">{{data.user.name}}</div>
    <div class="user-email">{{data.user.email}}</div>
  </div>
  <mat-form-field class="role-field">
    <mat-label>Organisation role</mat-label>
    <mat-select id="user-org-role" [formControl]="roleControl" required (selectionChange)="checkRole()">
      @for (role of roles; track role) {
        <mat-option [value]="role">{{getRoleName(role)}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <p class="role-description">{{getRoleDescription(roleControl.value)}}</p>
  @if (invalidRoleMessage) {
    <mat-error class="role-error">{{invalidRoleMessage}}</mat-error>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancelClick()">Cancel</button>
  <button mat-flat-button color="accent" cdkFocusInitial (click)="save()" [disabled]="isUnchanged() || !!invalidRoleMessage">Save</button>
</div>
